import React from "react";

const FooterContent = () => {
  return (
    <React.Fragment>
      <div className=" flex flex-col items-center text-white md:px-[5.2rem] font-normal relative">
        <div className=" z-10 w-[35.13rem] ">
          <img
            src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/innovation%20logo%20WHITE_1659561853673001lijH.png"
            alt="Intel Logo"
          />
        </div>

        <div className="z-10 text-lg pt-[5.8rem] pb-[8.4rem] md:pt-[8.8] md:pb-[9.5rem] 1400px:pt-[6.4rem] 1400px:pb-[8rem]">
          <ul className="flex flex-col gap-y-[2.7rem] text-center md:text-left md:gap-y-0 md:flex-row flex-wrap justify-between items-center md:gap-x-[4rem] 1400px:gap-x-[12rem]">
            <div className="flex flex-col gap-y-[2.7rem]">
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/jobs/jobs-at-intel.html"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Jobs
        </a>
              </li>
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/newsroom/home.html"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Newsroom
        </a>
              </li>
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/company-overview/contact-us.html"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Contact Us
        </a>
              </li>
            </div>

            <div className="flex flex-col gap-y-[2.7rem]">
              <li>
              <a
          href="https://www.intc.com/investor-relations/default.aspx"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Investor Relations
        </a>
              </li>
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/blogs-communities-social.html"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Communities
        </a>
              </li>
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/diversity/diversity-at-intel.html"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Diversity &amp; Inclusion
        </a>
              </li>
            </div>

            <div className="flex flex-col gap-y-[2.7rem]">
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/corporate-responsibility/corporate-responsibility.html"
          class="text-footer block hover:underline text-footer pr-4"
        >
          Our Commitment
        </a>
              </li>
              <li>
              <a
          href="https://www.intel.com/content/www/us/en/company-overview/company-overview.html"
          class="
            text-footer
            block
            hover:underline
            lg:inline-block
            text-footer
            pr-4
          "
        >
          Company Information
        </a>
              </li>
              {/* <li>
                <a href="#">Vitae dicta sunt explicabo</a>
              </li> */}
            </div>
          </ul>
        </div>

        <div className=" z-10 flex items-center flex-col md:flex-row justify-between">
          <div className="flex justify-between w-[22.8rem] pb-[2rem] md:pb-0">
            <a href="https://www.instagram.com/intel/">
              <img
                src="https://static.rainfocus.com/intel/vision2022/static/staticfile/staticfile/Instagram%20Logo_1647949324384001TBIY.png"
                alt="Instagram Link"
                className="w-[3.492rem]"
              />
            </a>
            <a href="https://www.linkedin.com/company/intel-corporation">
              <img
                src="https://static.rainfocus.com/intel/vision2022/static/staticfile/staticfile/Linked%20In%20Logo_1647949324247001T5N8.png"
                alt="LinkedIn"
                className="w-[3.492rem]"
              />
            </a>
            <a href="https://twitter.com/intel">
              <img
                src="https://static.rainfocus.com/intel/vision2022/static/staticfile/staticfile/Twitter%20Logo_1647949324101001TmxV.png "
                alt="Twitter"
                className="w-[3.492rem]"
              />
            </a>
            <a href="https://www.facebook.com/Intel">
              <img
                src="https://static.rainfocus.com/intel/vision2022/static/staticfile/staticfile/Facebook%20Logo_1647949323952001T5GN.png"
                alt="Facebook"
                className="w-[3.492rem]"
              />
            </a>
            <a href="https://www.youtube.com/user/channelintel?sub_confirmation=1">
              <img
                src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/youtube_icon_1661349521496001pSX2.png"
                alt="Youtube"
                className="w-[3.492rem]"
              />
            </a>
          </div>

          <div>
            <p className="text-[2rem] ml-[1rem]">&copy; 2022 All rights reserved.</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default FooterContent;
